import React, { useEffect, useState } from 'react';
import axios from "axios"
import './App.css';

function App() {

  const [malaysia, setMalaysia] = useState([]);
  const [singapore, setSingapore] = useState([]);
  const [taiwan, setTaiwan] = useState([]);
  const [philippines, setPhilipines] = useState([]);
  const [srilanka, setSrilanka] = useState([]);
  const [southkorea, setSouthkorea] = useState([]);
  const [china, setChina] = useState([]);
  const [thailand, setThailand] = useState([]);
  const [netherlands, setNld] = useState([]);
  const [denmark, setDenmark] = useState([]);

  useEffect(() => {
    axios
      .all([
        axios.get("https://corona.lmao.ninja/v2/countries/malaysia"),
        axios.get("https://disease.sh/v3/covid-19/countries/Singapore"),
        axios.get("https://disease.sh/v3/covid-19/countries/Taiwan"),
        axios.get("https://disease.sh/v3/covid-19/countries/Philippines"),
        axios.get("https://disease.sh/v3/covid-19/countries/lka"),
        axios.get("https://disease.sh/v3/covid-19/countries/kor"),
        axios.get("https://disease.sh/v3/covid-19/countries/China"),
        axios.get("https://disease.sh/v3/covid-19/countries/Thailand"),
        axios.get("https://disease.sh/v3/covid-19/countries/nld"),
        axios.get("https://disease.sh/v3/covid-19/countries/denmark"),
      ])
      .then((responseArr) => {
        setMalaysia(responseArr[0].data);
        setSingapore(responseArr[1].data);
        setTaiwan(responseArr[2].data);
        setPhilipines(responseArr[3].data);
        setSrilanka(responseArr[4].data);
        setSouthkorea(responseArr[5].data);
        setChina(responseArr[6].data);
        setThailand(responseArr[7].data);
        setNld(responseArr[8].data);
        setDenmark(responseArr[9].data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const date = new Date(parseInt(malaysia.updated));
  const lastUpdated = date.toString();
  var moment = require('moment'); // require
  let resultDate = moment(lastUpdated).format('LLL');

  return (
    <div className="App">
      <nav>
        <div><img src={process.env.PUBLIC_URL + '/logo.webp'} alt="Egg Venture"></img></div>
        <div><h1 className="logo">Updated on {resultDate}</h1></div>
      </nav>

      <div className="header">
        <h1>
          Your wellbeing is our priority ❤️
        </h1>
        <h3>
          At Egg Venture Technology, we keep track of the Covid-19 situation happening in the countries our
          customers are based in.
        </h3>
        <div className="links">
          <a href="#footer" rel="help" className="button">Learn more</a>
        </div>
      </div>

      <div className="container">
        <div className="card">
          <div className="country">
            <h2>🇲🇾 Malaysia</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {malaysia.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {malaysia.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {malaysia.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{malaysia.todayCases}), Recovered (+{malaysia.todayRecovered}),
              Deaths (+{malaysia.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇸🇬 Singapore</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {singapore.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {singapore.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {singapore.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{singapore.todayCases}), Recovered (+{singapore.todayRecovered}),
              Deaths (+{singapore.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇹🇼 Taiwan</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {taiwan.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin"> 
                  <span className="recovered">Recovered</span><br></br>
                  {taiwan.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {taiwan.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{taiwan.todayCases}), Recovered (+{taiwan.todayRecovered}),
              Deaths (+{taiwan.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇵🇭 Philippines</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {philippines.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {philippines.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {philippines.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{philippines.todayCases}), Recovered (+{philippines.todayRecovered}),
              Deaths (+{philippines.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇱🇰 Sri Lanka</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {srilanka.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {srilanka.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {srilanka.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{srilanka.todayCases}), Recovered (+{srilanka.todayRecovered}),
              Deaths (+{srilanka.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇰🇷 South Korea</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {southkorea.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin"> 
                  <span className="recovered">Recovered</span><br></br>
                  {southkorea.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {southkorea.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{southkorea.todayCases}), Recovered (+{southkorea.todayRecovered}),
              Deaths (+{southkorea.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇨🇳 China</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {china.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {china.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {china.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{china.todayCases}), Recovered (+{china.todayRecovered}),
              Deaths (+{china.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇹🇭 Thailand</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {thailand.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {thailand.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {thailand.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{thailand.todayCases}), Recovered (+{thailand.todayRecovered}),
              Deaths (+{thailand.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇳🇱 Netherlands</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {netherlands.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {netherlands.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {netherlands.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{netherlands.todayCases}), Recovered (+{netherlands.todayRecovered}),
              Deaths (+{netherlands.todayDeaths})
            
          </div>
        </div>

        <div className="card">
          <div className="country">
            <h2>🇩🇰 Denmark</h2>
          </div>

          <div className="number-container">
            <div className="number-card">
              <div>
                <h3 className="number-margin">
                  <span className="infected">Infected</span><br></br>
                  {denmark.cases}
                </h3>
              </div>
              <div>
                <h3 className="number-margin">
                  <span className="recovered">Recovered</span><br></br>
                  {denmark.recovered}
                </h3>
              </div>
              <div>
                <h3>
                  <span className="deaths">Deaths</span><br></br>
                  {denmark.deaths}
                </h3>
              </div>
            </div>
          </div>

          <div className="today-list">
            
              Infected (+{denmark.todayCases}), Recovered (+{denmark.todayRecovered}),
              Deaths (+{denmark.todayDeaths})
            
          </div>
        </div>
      </div>

      <div className="section">
        <h1>Covid tracker</h1>
        <h3>
          This Covid-19 tracker was made possible using the <a href="https://corona.lmao.ninja/docs/" target="_blank" rel="noreferrer">Novel CoVID19 API</a>.
          Data will reset sometime during the day. Please follow
          local authorities and the <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/question-and-answers-hub" target="_blank" rel="noreferrer">World Health Organization</a> for more detailed information on Covid-19.
        </h3>
      </div>

      <div className="footer" id="footer">
        <h1>
          About us
        </h1>
        <h3>
          Proudly based in Malaysia, Egg Venture Technology provides solutions to problems in the egg industry.
        </h3>
        <div className="links">
          <a href="https://wa.me/+60122556718" target="_blank" rel="noreferrer" className="button">WhatsApp</a>
          <a href="mailto:chewyeefat@gmail.com?subject=Egg%20Venture" className="button">Email</a>
        </div>
      </div>

    </div>
  );
}

export default App;
